// Recommended functionality
let RecommendedTagVal = $('.js-recommended-value').val();
let RecommendedTagHandle = $('.js-recommended-handle').val();
console.log('RecommendedTag', RecommendedTagVal);
console.log('RecommendedHandle', RecommendedTagHandle);
$.ajax({
    type: 'POST',
    url: 'https://somm-cellars.myshopify.com/api/2020-07/graphql.json',
    headers: {
        "X-Shopify-Storefront-Access-Token":'08bfbc84387336ea034e84202cc52400',
        'Content-Type': 'application/json'
    },
    data: JSON.stringify({
        query: `query($RecommendedTags: String!) {
        products(first:40, query: $RecommendedTags) {
        edges {
          cursor
          node {
            id
            handle
            title
            tags
            variants(first:1) {
              edges {
                node {
                  id
                  price
                }
              }
            }
            images(first:1) {
              edges {
                node {
                  src
                }
              }
            }
          }
        }
      }
    }`,
        variables: {
          "RecommendedTags": `${RecommendedTagVal} AND -tag:remove-klevu`
        }
    }),
    success: function(data) {
        var allProducts = new Object(data.data.products.edges);
        var allProductsLength = allProducts.length;
        console.log('allProductsLength', allProductsLength);
        if (allProductsLength > 1) {
            $('.js-btn-open-recommended').show();
        }
        $.each(allProducts,function(index,value){
            var handleItem = this.node.handle;
            var handleItemCheck = handleItem.includes(RecommendedTagHandle);
            if (handleItemCheck === true) {
                let indexRemovedItem = index;
                $('.js-recommended-remove-item-position').val(indexRemovedItem);
            }
        });
        var itemRemovedPosition = Number($('.js-recommended-remove-item-position').val());
        allProducts.splice(itemRemovedPosition, 1);
        var allProductsRandom = allProducts.map(item => item);
        for (let i = 0; i < 4; i++) {
            var ind = Math.floor(Math.random() * allProductsRandom.length);
            var selectProductsRandom = allProductsRandom.splice(ind, 1);
            var selectProductsRandomItems = selectProductsRandom[0].node;

            var selectProductsRandomItemTitle = selectProductsRandomItems.title;
            var selectProductsRandomItemHandle = selectProductsRandomItems.handle;
            var selectProductsRandomItemImage = selectProductsRandomItems.images.edges[0].node.src;
            var selectProductsRandomItemPrice = selectProductsRandomItems.variants.edges[0].node.price;

            console.log("Title:", selectProductsRandomItemTitle);
            console.log("Handle:", selectProductsRandomItemHandle);
            console.log("Image:", selectProductsRandomItemImage);
            console.log("Price:", selectProductsRandomItemPrice);
            console.log("----------------------");

            $('.js-recommendations-wrapper .grid.grid--uniform').append('' +
                '<div class="grid__item grid-product small--one-half medium-up--one-quarter">' +
                '<div class="grid-product__content">' +
                '<a href="'+selectProductsRandomItemHandle+'">' +
                '<div><img alt="" src="'+selectProductsRandomItemImage+'"></div>' +
                '<div class="grid-product__content-title">'+selectProductsRandomItemTitle+'</div>' +
                '<div class="grid-product__content-price">$'+selectProductsRandomItemPrice+'</div>' +
                '</a>' +
                '</div>' +
                '</div>' +
                '');

        }
    }
});

$('.js-btn-open-recommended').click(function(){
    $('html,body').animate({
        scrollTop:$('.js-recommendations-wrapper').offset().top - 180 +"px"},{
        duration: 700
    });
    $('.recommendations-wrapper').show();
    setTimeout(function() {
        $('.recommendations-spinner').addClass('recommendations-spinner-close');
    }, 4000);
});